import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  AccountCircleOutlined,
  AttachFile,
  PriorityHighOutlined,
  StairsOutlined,
  HistoryEduOutlined,
  AccessTimeOutlined,
} from "@mui/icons-material";
import ReactHtmlParser from "html-react-parser";

import { useFeedbackDetailContext } from "contexts/FeedbackDetailContext";

import FileIcon from "components/Shared/FileIcon";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

import { localizeDateMed } from "utils/dateFormats";

const FeedbackBasicDetail = () => {
  const { feedbackDetail, loadingFeedback } = useFeedbackDetailContext();

  return !loadingFeedback ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Typography variant="h6">{feedbackDetail?.title}</Typography>
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <PriorityHighOutlined color="primary" />}
            title="Priority"
            subtitle={feedbackDetail?.priority}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <StairsOutlined color="primary" />}
            title="Stage"
            subtitle={feedbackDetail?.stage}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <HistoryEduOutlined color="primary" />}
            title="Requested By"
            subtitle={feedbackDetail?.createdBy?.name}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <AccessTimeOutlined color="primary" />}
            title="Created At"
            subtitle={new Date(feedbackDetail?.createdAt).toUTCString()}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <AccountCircleOutlined color="primary" />}
            title="Responsible"
            subtitle={feedbackDetail?.responsible?.name}
          />
        </Grid>

        {feedbackDetail?.updatedBy && (
          <Grid item md={4}>
            <InformationTile
              icon={() => <HistoryEduOutlined color="primary" />}
              title="Recently Updated By"
            >
              <span>{feedbackDetail?.updatedBy?.name} </span>
              <span className="text-gray-400">
                on {localizeDateMed(feedbackDetail?.updatedAt)}
              </span>
            </InformationTile>
          </Grid>
        )}

        {!!feedbackDetail?.attachments?.length && (
          <Grid item md={12}>
            <InformationTile
              icon={() => <AttachFile color="primary" />}
              title="Attachments"
            >
              <div className="flex gap-4">
                {feedbackDetail?.attachments?.map((attachment) => (
                  <a
                    key={attachment?._id}
                    href={attachment?.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "var(--primary)" }}
                  >
                    <FileIcon
                      fileName={attachment?.name}
                      fileUrl={attachment?.url}
                    />
                  </a>
                ))}
              </div>
            </InformationTile>
          </Grid>
        )}
      </Grid>

      <br />

      {feedbackDetail?.description && (
        <Box>{ReactHtmlParser(feedbackDetail?.description)}</Box>
      )}
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default FeedbackBasicDetail;
